/**
 * useUiMode (TV-LM-1, 2026-06-02)
 *
 * Read-only accessor for the current UI mode. Single place every
 * component imports from so we can rename the underlying field or
 * promote it from sessionStore → tenant config without rewriting
 * every call site.
 *
 *   const mode = useUiMode();            // 'full' | 'lite'
 *   const isLite = mode === 'lite';
 *   const { isLite, isFull } = useUiModeFlags();
 *
 * Set by SmartLaunch (TV-LM-2) once per launch based on the
 * `?mode=lite` query param. Defaults to 'full' for every other
 * entry path (callback resume, direct re-open of a /visit URL,
 * Storybook).
 */

import { useSessionStore } from '@/stores/sessionStore';

/** Returns the current UI mode literal — 'full' (default) or 'lite'. */
export function useUiMode() {
  return useSessionStore((state) => state.uiMode ?? 'full');
}

/** Sugar for components that prefer booleans over string comparisons. */
export function useUiModeFlags() {
  const mode = useUiMode();
  return {
    mode,
    isLite: mode === 'lite',
    isFull: mode === 'full',
  };
}
